import { ReducerAction, ReducerHandler } from '../../Types';
import { StoreJoyride } from '../../Types/StoreTypes';
import { SET_STEP_INDEX, SET_RUN, SET_START_TOUR } from '../Actions/joyrideActions';

const initialState = {
    run: false,
    stepIndex: 0,
    startTour: false,
} as StoreJoyride;

const joyrideReducerMap: Record<string, ReducerHandler<StoreJoyride>> = {
    [SET_STEP_INDEX]: (state, action) => ({ ...state, stepIndex: action.payload }),
    [SET_RUN]: (state, action) => ({ ...state, run: action.payload }),
    [SET_START_TOUR]: (state, action) => ({ ...state, startTour: action.payload }),
};

function joyrideReducer(state = initialState, action: ReducerAction): StoreJoyride {
    const handler = joyrideReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default joyrideReducer;
